export const LANGS = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

export const TAGLINE = ["Rinasci.", "Evolvi.", "Investi."];

export const translations = {
  it: {
    eyebrow: "Hub ufficiale",
    cookie: {
      text: "Usiamo solo l'archiviazione tecnica necessaria al funzionamento dell'app (come la lingua scelta) e statistiche anonime dei tap. Nessun cookie pubblicitario.",
      link: "Privacy Policy",
      ok: "Ho capito",
    },
    scroll: "Scorri",
    collab: {
      title: "In collaborazione con",
      logoSoon: "Logo in arrivo",
      lead: "Be Five% e RiseVision uniscono le forze con SYNrise.",
      mission: ["Tre community.", "Un'unica missione."],
      desc: "Farti crescere con visione, disciplina e la mentalità del 5%.",
      pillars: ["Visione", "Disciplina", "Mentalità del 5%"],
    },
    actions: {
      kicker: "Canali ufficiali",
      title: "Inizia da qui",
      soon: "Link in arrivo a breve",
      etoro: { title: "Registrati su eToro", sub: "Apri il tuo account tramite il link ufficiale SYNrise.", risk: "Il tuo capitale è a rischio." },
      results: { title: "Risultati e testimonianze", sub: "Screenshot e testimonianze condivisi dalle community SYNrise, Be Five% e RiseVision." },
      telegram: { title: "Canale Free SYNrise", sub: "Entra nel canale Telegram gratuito della community.", badge: "FREE" },
      instagram: { title: "Seguimi su Instagram", sub: "Contenuti, aggiornamenti e dietro le quinte." },
      website: { title: "Sito SYNrise", sub: "Visita il sito ufficiale e l'area membri." },
      trustpilot: { title: "Valutaci su Trustpilot", sub: "Lascia la tua recensione: il tuo parere conta." },
    },
    share: {
      kicker: "Passaparola",
      title: "Porta SYNrise con te",
      sub: "Condividi l'app con chi vuole crescere insieme a noi.",
      button: "Condividi SYNrise",
      dialogTitle: "Condividi SYNrise",
      dialogSub: "Inquadra il QR code oppure scegli dove inviarlo.",
      copy: "Copia link",
      copied: "Link copiato!",
      text: "Scopri SYNrise — Rinasci. Evolvi. Investi.",
    },
    install: {
      button: "Installa app",
      title: "Aggiungi SYNrise alla Home",
      sub: "Nessuno store, nessun download: si apre come un'app.",
      ios: ["Tocca l'icona Condividi di Safari", "Scegli «Aggiungi alla schermata Home»", "Conferma con «Aggiungi»"],
      ok: "Ho capito",
    },
    disclaimer: {
      title: "Disclaimer",
      body: [
        "SYNrise è un progetto indipendente, curato da un investitore retail, con finalità esclusivamente informative e formative.",
        "I contenuti condivisi non costituiscono consulenza finanziaria, raccomandazione d’investimento, offerta o sollecitazione all’acquisto o alla vendita di strumenti finanziari. Ogni decisione di investimento deve essere presa autonomamente, in base alla propria situazione finanziaria, esperienza e propensione al rischio.",
        "Gli investimenti comportano rischi e possono determinare la perdita parziale o totale del capitale. I CFD sono strumenti complessi e presentano un elevato rischio di perdita rapida a causa della leva finanziaria.",
        "Le performance passate non sono indicative né garantiscono risultati futuri.",
        "SYNrise non gestisce capitali per conto degli utenti e non sostituisce l’attività di un consulente finanziario abilitato o di un intermediario autorizzato.",
      ],
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    eyebrow: "Official hub",
    cookie: {
      text: "We only use the technical storage needed to run the app (such as your chosen language) and anonymous tap statistics. No advertising cookies.",
      link: "Privacy Policy",
      ok: "Got it",
    },
    scroll: "Scroll",
    collab: {
      title: "In collaboration with",
      logoSoon: "Logo coming soon",
      lead: "Be Five% and RiseVision join forces with SYNrise.",
      mission: ["Three communities.", "One mission."],
      desc: "To help you grow with vision, discipline and the 5% mindset.",
      pillars: ["Vision", "Discipline", "The 5% mindset"],
    },
    actions: {
      kicker: "Official channels",
      title: "Start here",
      soon: "Link coming soon",
      etoro: { title: "Join eToro", sub: "Open your account through the official SYNrise link.", risk: "Your capital is at risk." },
      results: { title: "Results & testimonials", sub: "Screenshots and testimonials shared by the SYNrise, Be Five% and RiseVision communities." },
      telegram: { title: "SYNrise Free Channel", sub: "Join the community's free Telegram channel.", badge: "FREE" },
      instagram: { title: "Follow me on Instagram", sub: "Content, updates and behind the scenes." },
      website: { title: "SYNrise Website", sub: "Visit the official website and members area." },
      trustpilot: { title: "Rate us on Trustpilot", sub: "Leave your review — your opinion matters." },
    },
    share: {
      kicker: "Spread the word",
      title: "Take SYNrise with you",
      sub: "Share the app with anyone who wants to grow with us.",
      button: "Share SYNrise",
      dialogTitle: "Share SYNrise",
      dialogSub: "Scan the QR code or choose where to send it.",
      copy: "Copy link",
      copied: "Link copied!",
      text: "Discover SYNrise — Rinasci. Evolvi. Investi.",
    },
    install: {
      button: "Install app",
      title: "Add SYNrise to your Home Screen",
      sub: "No store, no download: it opens just like an app.",
      ios: ["Tap the Share icon in Safari", "Choose “Add to Home Screen”", "Confirm with “Add”"],
      ok: "Got it",
    },
    disclaimer: {
      title: "Disclaimer",
      body: [
        "SYNrise is an independent project run by a retail investor, for informational and educational purposes only.",
        "The content shared does not constitute financial advice, investment recommendations, or an offer or solicitation to buy or sell financial instruments. Every investment decision must be made independently, based on your own financial situation, experience and risk tolerance.",
        "Investing involves risk and may result in the partial or total loss of capital. CFDs are complex instruments and carry a high risk of losing money rapidly due to leverage.",
        "Past performance is not indicative of, nor does it guarantee, future results.",
        "SYNrise does not manage capital on behalf of users and does not replace the services of a licensed financial advisor or an authorized intermediary.",
      ],
      rights: "All rights reserved.",
    },
  },
  es: {
    eyebrow: "Hub oficial",
    cookie: {
      text: "Solo usamos el almacenamiento técnico necesario para que la app funcione (como el idioma elegido) y estadísticas anónimas de toques. Sin cookies publicitarias.",
      link: "Política de privacidad",
      ok: "Entendido",
    },
    scroll: "Desliza",
    collab: {
      title: "En colaboración con",
      logoSoon: "Logo próximamente",
      lead: "Be Five% y RiseVision unen fuerzas con SYNrise.",
      mission: ["Tres comunidades.", "Una única misión."],
      desc: "Hacerte crecer con visión, disciplina y la mentalidad del 5%.",
      pillars: ["Visión", "Disciplina", "Mentalidad del 5%"],
    },
    actions: {
      kicker: "Canales oficiales",
      title: "Empieza aquí",
      soon: "Enlace disponible próximamente",
      etoro: { title: "Regístrate en eToro", sub: "Abre tu cuenta a través del enlace oficial de SYNrise.", risk: "Tu capital está en riesgo." },
      results: { title: "Resultados y testimonios", sub: "Capturas y testimonios compartidos por las comunidades SYNrise, Be Five% y RiseVision." },
      telegram: { title: "Canal Free SYNrise", sub: "Únete al canal gratuito de Telegram de la comunidad.", badge: "FREE" },
      instagram: { title: "Sígueme en Instagram", sub: "Contenido, novedades y detrás de cámaras." },
      website: { title: "Web SYNrise", sub: "Visita la web oficial y el área de miembros." },
      trustpilot: { title: "Valóranos en Trustpilot", sub: "Deja tu reseña: tu opinión cuenta." },
    },
    share: {
      kicker: "Corre la voz",
      title: "Lleva SYNrise contigo",
      sub: "Comparte la app con quien quiera crecer con nosotros.",
      button: "Compartir SYNrise",
      dialogTitle: "Compartir SYNrise",
      dialogSub: "Escanea el código QR o elige dónde enviarlo.",
      copy: "Copiar enlace",
      copied: "¡Enlace copiado!",
      text: "Descubre SYNrise — Rinasci. Evolvi. Investi.",
    },
    install: {
      button: "Instalar app",
      title: "Añade SYNrise a tu pantalla de inicio",
      sub: "Sin tiendas ni descargas: se abre como una app.",
      ios: ["Toca el icono Compartir de Safari", "Elige «Añadir a pantalla de inicio»", "Confirma con «Añadir»"],
      ok: "Entendido",
    },
    disclaimer: {
      title: "Aviso legal",
      body: [
        "SYNrise es un proyecto independiente, gestionado por un inversor minorista, con fines exclusivamente informativos y formativos.",
        "Los contenidos compartidos no constituyen asesoramiento financiero, recomendación de inversión, oferta ni invitación a comprar o vender instrumentos financieros. Cada decisión de inversión debe tomarse de forma autónoma, según la propia situación financiera, experiencia y tolerancia al riesgo.",
        "Las inversiones conllevan riesgos y pueden provocar la pérdida parcial o total del capital. Los CFD son instrumentos complejos y presentan un elevado riesgo de pérdida rápida debido al apalancamiento.",
        "Las rentabilidades pasadas no son indicativas ni garantizan resultados futuros.",
        "SYNrise no gestiona capitales por cuenta de los usuarios y no sustituye la actividad de un asesor financiero habilitado ni de un intermediario autorizado.",
      ],
      rights: "Todos los derechos reservados.",
    },
  },
};
